import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=2e7ccddc&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ccddc",
  null
  
)

export default component.exports